import { useCallback } from 'react';
import html2canvas from 'html2canvas';

export const useChartShare = () => {
    const captureAndShare = useCallback(async (element: HTMLElement | null, fileName: string) => {
        if (!element) return;

        try {
            // Capture the element
            const canvas = await html2canvas(element, {
                backgroundColor: '#ffffff', // Ensure white background
                scale: 2, // Higher quality
                logging: false,
                useCORS: true, // For external images if any
            });

            // Create a new canvas to add watermark
            const finalCanvas = document.createElement('canvas');
            finalCanvas.width = canvas.width;
            finalCanvas.height = canvas.height;
            const ctx = finalCanvas.getContext('2d');

            if (!ctx) return;

            // Draw original chart
            ctx.drawImage(canvas, 0, 0);

            // Add Watermark
            const text = 'Kanea';
            const fontSize = Math.max(16, canvas.width * 0.03); // Responsive font size
            ctx.font = `bold ${fontSize}px Arial, sans-serif`;
            ctx.fillStyle = 'rgba(0, 0, 0, 0.2)'; // Semi-transparent gray
            ctx.textAlign = 'right';
            ctx.textBaseline = 'bottom';

            // Position: Bottom Right with padding
            const padding = 20;
            ctx.fillText(text, canvas.width - padding, canvas.height - padding);

            // Trigger Download
            const link = document.createElement('a');
            link.download = `${fileName}_${new Date().toISOString().split('T')[0]}.png`;
            link.href = finalCanvas.toDataURL('image/png');
            link.click();
        } catch (error) {
            console.error('Error capturing chart:', error);
        }
    }, []);

    return { captureAndShare };
};
